import Modal from '@acorn-portal/shared/src/components-v2/modal';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import ModalContentWrapper from '../../modal-content-wrapper';
import Typography from '@mui/material/Typography';
import useTrack from '@acorn-portal/shared/src/hooks/useTrack/useTrack';
import { useEffect } from 'react';
import { useStepIndex } from '@acorn-portal/shared/src/pages/cancellation/hooks/use-step-index/ use-step-index';

interface ILeaveModal {
	open: boolean;
	onClose: () => void;
	onLeave: () => void;
	isLeaving?: boolean;
	stepNumber: number;
}

const MODAL_NAME = 'cancellation_journey_abandoned_modal';

const LeaveModal = ({ open, onClose, onLeave, isLeaving = false, stepNumber }: ILeaveModal) => {
	const { track } = useTrack();
	const stepCeilingIndex = useStepIndex();

	useEffect(() => {
		if (!open) return;
		track('cancellation_journey_abandoned_modal_open', { name: MODAL_NAME, step_number: stepNumber });
	}, [open]);

	const onLeaveClick = () => {
		track('cancellation_journey_abandoned', { name: MODAL_NAME, last_step_reached: stepCeilingIndex + 1 });
		onLeave();
	};

	const onCloseClick = () => {
		track('cancellation_journey_abandoned_modal_close', { name: MODAL_NAME, step_number: stepNumber });
		onClose();
	};

	return (
		<Box>
			<Modal open={open} onClose={onCloseClick}>
				<ModalContentWrapper>
					<DialogTitle component='h2' variant='h5' sx={{ fontWeight: 700, m: 0, p: 0, textAlign: 'center' }}>
						Are you sure you want to leave?
					</DialogTitle>
					<Typography variant='body1' sx={{ textAlign: 'center', mt: '16px', mb: '24px' }}>
						Leaving will mean all of your progress will be lost and your policy won&apos;t be cancelled.
					</Typography>
					<Button
						variant='contained'
						onClick={onLeaveClick}
						size='large'
						disabled={isLeaving}
						sx={{
							width: '100%',
						}}
					>
						Leave and lose progress
					</Button>
					<Button
						variant='text'
						onClick={onCloseClick}
						size='large'
						disabled={isLeaving}
						sx={{
							border: 'solid 1px',
							color: 'primary.dark',
							borderColor: 'primary.dark',
							px: '1rem',
							width: '100%',
							mt: '1em',
						}}
					>
						Continue cancellation
					</Button>
				</ModalContentWrapper>
			</Modal>
		</Box>
	);
};

export default LeaveModal;
